(function(){

    puremvc.define
    (
        // CLASS INFO
        {
            name: 'sinewav3.controller.command.state.closing.ChangedCommand',
            parent: puremvc.SimpleCommand
        },

        // INSTANCE MEMBERS
        {
            execute: function (note) {

                console.log("state/closing/ChangedCommand: State changed to CLOSING");

                // Trigger next state
                this.facade.triggerAction( sinewav3.fsm.action.DESTROY );

            }
        }
    );

})();